class Fetch {
    static post(route, init={}) {
        const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
        if (init.body && !(typeof init.body === 'string')) init.body = JSON.stringify(init.body);
        return fetch(route, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-Token': csrfToken
            },
            ...init
        })
        .then(async (res) => {
            if (!res.ok) {
                const { message } = await res.json();
                throw new Error(message);
            }
            return res;
        })
        .then((res) => res.json());
    }

    static get(route, init = {}) {
        return fetch(route, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
        .then(async (res) => {
            if (!res.ok) {
                const { message } = await res.json();
                throw new Error(message);
            }
            return res;
        })
        .then((res) => res.json());
    }

    static patch(route, init = {}) {
        const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
        if (init.body && !(typeof init.body === 'string')) init.body = JSON.stringify(init.body);
        return fetch(route, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-Token': csrfToken
            },
            ...init
        })
        .then(async (res) => {
            if (!res.ok) {
                const { message } = await res.json();
                throw new Error(message);
            }
            return res;
        })
        .then((res) => res.json());
    }
}

export default Fetch;
